import React from 'react';
import { DollarOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { theme } from '../utils/theme';

const { Title, Text } = Typography;

const Billing = () => (
  <div style={{ textAlign: 'center', padding: '40px 0' }}>
    <DollarOutlined style={{ fontSize: '64px', color: theme.primaryBlue, marginBottom: '16px' }} />
    <Title level={4}>Billing Module</Title>
    <Text type="secondary" style={{ maxWidth: '500px', margin: '0 auto' }}>
      Manage patient invoices, insurance claims, and payment processing.
    </Text>
  </div>
);

export default Billing;